import axios from 'axios';

export const API = axios.create({
  baseURL: 'https://viajeros-backend.onrender.com/api/', 
});